import { z } from 'zod';
import { FormConfig } from '@/services/FormService';

export const bodyCompositionFormSchema = z.object({
  recorded_date: z.string(),
  total_weight: z.number().min(20).max(300).optional(),
  body_fat_percentage: z.number().min(1).max(60).optional(),
  skeletal_muscle_mass: z.number().min(10).max(150).optional(),
  bmr: z.number().min(800).max(5000).optional(),
  notes: z.string().optional(),
});

export const bodyCompositionFormConfig: FormConfig = {
  fields: [
    {
      name: 'recorded_date',
      type: 'date',
      label: 'Date',
      required: true,
    },
    {
      name: 'total_weight',
      type: 'number',
      label: 'Total Weight (kg)',
      placeholder: 'e.g., 70.5',
      min: 20,
      max: 300,
      step: 0.1,
    },
    {
      name: 'body_fat_percentage',
      type: 'number',
      label: 'Body Fat Percentage (%)',
      placeholder: 'e.g., 15.5',
      min: 1,
      max: 60,
      step: 0.1,
    },
    {
      name: 'skeletal_muscle_mass',
      type: 'number',
      label: 'Skeletal Muscle Mass (kg)',
      placeholder: 'e.g., 35.2',
      min: 10,
      max: 150,
      step: 0.1,
    },
    {
      name: 'bmr',
      type: 'number',
      label: 'BMR (calories/day)',
      placeholder: 'e.g., 1800',
      min: 800,
      max: 5000,
      step: 1,
    },
    {
      name: 'notes',
      type: 'textarea',
      label: 'Notes',
      placeholder: 'Any observations or comments...',
    },
  ],
  submitLabel: 'Save Body Composition',
  validation: bodyCompositionFormSchema,
  autoSave: false,
};